import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Checkbox } from '../../ui-kit/Checkbox/Checkbox.js';
import { Foldable } from '../../ui-kit/Foldable/Foldable.js';
import { FoldableSection } from '../../ui-kit/Foldable/FoldableSection.js';
import { Icon } from '../../ui-kit/Icon/Icon.js';
import { LinkButton } from '../../ui-kit/LinkButton/LinkButton.js';
const FILTRATION_LABELS = {
    safeBoxCaseVolumes: 'Аренда индивидуальных сейфовых ячеек',
    workingSaturday: 'Открыты по субботам',
    terminalTypeAtms: 'Банкоматы',
    terminalTypeTerm: 'Терминалы',
    workAllTime: 'Круглосуточно',
    billAcceptorEnable: 'Прием наличных',
    premiumService: 'Премиальное обслуживание',
    privateBanking: 'Услуга Private banking',
    sellingCoins: 'Продажа монет из драгоценных металлов',
    buyingCoins: 'Покупка монет из драгоценных металлов',
    bullionOperations: 'Операции со слитками',
    preciousMetalsOperations: 'Операции с драгоценными металлами',
    transferringDataToBiometricSystem: 'Передача фото и голоса в Единую биометрическую систему',
    locationDisabledPeople: 'Для маломобильных',
    designDisabledPeople: 'Для слабовидящих',
    remoteWorkplace: 'Удаленное рабочее место',
    serviceDisabledPeople: 'Для маломобильных граждан',
};
const COMMON_FILTERS_STYLES = 'flex flex-col sm:flex-row sm:flex-wrap gap-3xl pb-2xl';
export const renderFiltrationForm = (filters, { field, reset }, onlyOffice) => {
    const visibleFiltersNum = onlyOffice ? 5 : 6;
    const filtersCheckbox = (filters || []).map((key) => (_jsx(Checkbox, { text: FILTRATION_LABELS[key], ...field(key) }, key)));
    const [visibleFilters, hiddenFilters] = visibleFiltersNum > 0
        ? [filtersCheckbox.slice(0, visibleFiltersNum), filtersCheckbox.slice(visibleFiltersNum)]
        : [filtersCheckbox, []];
    return (_jsx("div", { children: filters?.length ? (_jsx("div", { children: _jsx(Foldable, { renderFoldableSection: ({ isUnfolded }) => (_jsxs("div", { children: [_jsx("div", { className: COMMON_FILTERS_STYLES, children: visibleFilters }), _jsx(FoldableSection, { className: COMMON_FILTERS_STYLES, isUnfolded: isUnfolded, children: hiddenFilters })] })), renderFoldButton: renderFoldButton(reset, onlyOffice) }) })) : null }));
};
export const renderFoldButton = (reset, onlyOffice) => ({ isUnfolded, onToggle }) => {
    const labels = ['Больше фильтров', 'Меньше фильтров'];
    const icons = ['ArrowDownIcon', 'ArrowUpIcon'];
    return (_jsxs("div", { className: "flex space-x-lg", children: [onlyOffice ? (_jsx(LinkButton, { version: "transparent", className: "text-secondary-text [&>*]:p-0", appendRight: _jsx(Icon, { name: icons[Number(isUnfolded)], width: "16", height: "16" }), text: labels[Number(isUnfolded)], onClick: onToggle })) : null, _jsx(LinkButton, { version: "transparent", className: "text-secondary-text [&>*]:p-0", onClick: reset, children: renderBtnInner() })] }));
};
const renderBtnInner = () => (_jsxs("div", { className: "flex items-center", children: ["\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440", _jsx(Icon, { name: "CloseIcon", width: "16", height: "16", className: "ml-2xs" })] }));
//# sourceMappingURL=renderFiltrationForm.js.map